import React from "react";
import PropTypes from "prop-types";
import cs from "classnames";

import { VARIANTS } from "./utilities";
import classes from "./PillButton.module.scss";

const PillButton = ({
  children,
  icon,
  variant,
  iconShape,
  className,
  gap,
  minWidth,
  alignItems,
  justifyContent,
  style,
  ...properties
}) => {
  const layoutOverrides = {
    ...(gap !== undefined && { gap }),
    ...(minWidth !== undefined && { minWidth }),
    ...(alignItems !== undefined && { alignItems }),
    ...(justifyContent !== undefined && { justifyContent }),
    ...style,
  };

  return (
    <button
      className={cs(
        classes.container,
        classes[variant],
        { [classes.noIcon]: !icon },
        className
      )}
      style={Object.keys(layoutOverrides).length ? layoutOverrides : undefined}
      {...properties}
    >
      {icon ? (
        <span
          className={
            iconShape === "pill" ? classes.iconWrapPill : classes.iconWrap
          }
        >
          {icon}
        </span>
      ) : null}

      {children ? <span>{children}</span> : null}
    </button>
  );
};

PillButton.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.node,
  variant: PropTypes.oneOf(Object.values(VARIANTS)),
  iconShape: PropTypes.oneOf(["circle", "pill"]),
  className: PropTypes.string,
  gap: PropTypes.string,
  minWidth: PropTypes.string,
  alignItems: PropTypes.string,
  justifyContent: PropTypes.string,
  style: PropTypes.object,
};

PillButton.defaultProps = {
  variant: VARIANTS.YELLOW,
  iconShape: "circle",
};

export default PillButton;
